export function apiErrorMessage(err, fallback) {
	const data = err?.response?.data;
	if (typeof data === "string" && data.trim()) return data.trim();
	if (data?.message) return data.message;
	if (err?.message && !/status code \d+/i.test(err.message)) return err.message;
	return fallback;
}

export function apiErrorData(err) {
	const data = err?.response?.data?.data;
	return data && typeof data === "object" ? data : null;
}
